import { render, staticRenderFns } from "./ServiceGroupList.vue?vue&type=template&id=6614a0d6&"
import script from "./ServiceGroupList.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports